<template>
    <span>
        <b-button
            v-if="button"
            variant="flat-primary"
            class="btn-icon btn-sm"
            :id="id"
        >
            <feather-icon icon="InfoIcon" />
        </b-button>
        <span
            v-else
            class="text-primary"
            :id="id"
        >
            <feather-icon icon="InfoIcon" />
        </span>
        <b-popover
            :target="id"
            triggers="hover"
            :custom-class="customClass"
        >
            <template #title>{{ title }}</template>
            <template #default><slot/></template>
        </b-popover>
    </span>

</template>

<script>
import {BButton, BPopover} from "bootstrap-vue"
export default {
    components: {BButton, BPopover},
    props: {
        customClass: {
            default: ''
        },
        button: {
            default: true
        },
        instruction: {
            default: ''
        },
        title: {
            default: ''
        },
        variant: {
            default: 'primary'
        },
    },
    data() {
        return {
            id: (Math.random() + 1).toString(36).substring(7)
        }
    }
}
</script>
